export default __webpack_public_path__ + "static/The Home_Image 4_carousel 2@2x-a0f87ca455b920942e372eccf035b609.jpg";